import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.birdChart`;
export const CHART_SCOPE = `${SCOPE}.chart`;
export const ZOOM_CHART_REQUEST_SCOPE = `${SCOPE}.zoomChartRequest`;
export const BRUSH_CHART_REQUEST_SCOPE = `${SCOPE}.brushChartRequest`;
export const BRUSH_COMPARE_CHART_REQUEST_SCOPE = `${SCOPE}.brushCompareChartRequest`;
export const SECONDARY_LINE_CHART_REQUEST_SCOPE = `${SCOPE}.secondaryLineChartRequest`;
export const SECONDARY_COMPARE_LINE_CHART_REQUEST_SCOPE = `${SCOPE}.secondaryCompareLineChartRequest`;

export const INIT_CHART = `${CHART_SCOPE}/INIT_CHART`;

export const RESET_CHART = `${CHART_SCOPE}/RESET_CHART`;

export const SET_DEFAULT_SLICE = `${CHART_SCOPE}/SET_DEFAULT_SLICE`;

export const SET_SLICE = `${CHART_SCOPE}/SET_SLICE`;

export const INJECT_SHARED_STATE = `${CHART_SCOPE}/INJECT_SHARED_STATE`;
